













































































































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import Swiper from 'swiper';
import { Route } from "vue-router";
import ContentContainer from "../../components/ContentContainer.vue";
import MaterialContentSlide from "../../components/MaterialContentSlide.vue";
import NumberedLine from "../../components/NumberedLine.vue";
import AdvantagesAndMaterialsSlider from "../../components/AdvantagesAndMaterialsSlider.vue";

@Component({
  components: {
    ContentContainer,
    NumberedLine,
    MaterialContentSlide,
    AdvantagesAndMaterialsSlider
  }
})
export default class ObjectPageMaterials extends Vue {
  @Prop() visibleScreenNumber!: number;
  @Prop() activeScreenNumber!: number;
  @Prop() screenNumber!: number;
  @State(state => state.app.loadingScreenAnimationEnded) loadingAnimationEnded!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  activeSlide = 1;
  screenActive = false;

  $refs!: {
    screen: HTMLElement;
    container: HTMLElement;
    slider: AdvantagesAndMaterialsSlider
  };

  lineSelectItem(number: number) {
    this.activeSlide = number;
    this.$refs.slider.selectItem(number);
  }

  sliderItemChange(number: number) {
    this.activeSlide = number;
  }

  @Emit("change-screen")
  changeScreen() { }

  get screenHeight() {
    return (this.$browser.height < 350) ? 350 : this.$browser.height;
  }

  get containerHeight() {
    let height = (this.scrollingByScreens) ? this.screenHeight - 130 : this.screenHeight - 30
    return height;
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/

  alreadyEntered = false;

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (prevNumber == this.screenNumber && this.scrollingByScreens) {
      this.screenLeave();
    }
  }

  /** Следующий экран появляется*/
  @Watch("visibleScreenNumber")
  visibleScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (nextNumber == this.screenNumber && (this.scrollingByScreens || !this.alreadyEntered)) {
      this.screenEnter(prevNumber);
      this.alreadyEntered = true;
    }

    if (nextNumber == this.screenNumber) {
      localStorage.setItem("screen", "Материалы");
    }
  }

  /** Появление */
  screenEnter(prevScreenNumber: number) {
    this.screenActive = true;
  }

  /** Исчезание */
  screenLeave() {
    this.screenActive = false;
    setTimeout(() => {
      this.changeScreen();
    }, 800);
  }
}
